/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useState } from "react";
import { Container, Breadcrumb, BreadcrumbItem, Modal, ModalBody, ModalHeader, CardText, CardTitle, Card, Button, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { GoogleMap, useJsApiLoader, Marker, InfoWindow } from '@react-google-maps/api';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { FiShare2, FiBriefcase } from "react-icons/fi";
import { AiOutlineStar, AiFillStar } from "react-icons/ai";
import { BiDotsVerticalRounded, BiExitFullscreen } from "react-icons/bi";
import { MdLocationOn } from "react-icons/md";
import GeoLocation from '../../components/GeoLocation/GeoLocation';
import "./ExploreNearMe.scss";
import { showPointList } from "../../utils/action/Action";
import SelectRouteModal from "../../components/Modals/SelectRouteModal";
import CreateNewRouteModal from "../../components/Modals/CreateNewRouteModal";
import PointsListingModal from "../../components/Modals/PointsListingModal";
import ReportSuggestionModal from "../../components/Modals/ReportSuggestionModal";
import ShareModal from "../../components/Modals/ShareModal";
import swal from "sweetalert";
import { addUserFavorite, removeUserFavorite } from "../../services/favourites.service";
import { routeDetail, updateRouteDetail } from "../../services/myRoute.service";
import marked_pop from "../../assets/marked_pop.svg";

const containerStyle = {
    width: '100%',
    height: '650px'
};

function ExploreNearMe({ isUserLoggedIn }) {
    const [activeMarker, setActiveMarker] = useState(null);
    const [dropdownMenuOpen, setMenuOpen] = useState(false);
    const [showReportModal, setShowReportModal] = useState(false);
    const [showShareModal, setShowShareModal] = useState(false);
    const [pointName, setPointName] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showListModal, setShowListModal] = useState(false);
    const [showPermissionModal, setShowPermissionModal] = useState(true);
    const [routeName, setRouteName] = useState(null);
    const [showCreateRouteModal, setShowCreateRouteModal] = useState(false);
    const [map, setMap] = useState(/**@type window?.google?.maps?.Map*/(null));
    const [checkForFavorite, setCheckForFavorite] = useState(null);
    const [route, setRoute] = useState(null);
    const [mkmID, setMkmId] = useState();
    const [link, setLink] = useState('');
    const [mounted, setMounted] = useState(true);
    const [showSpinner, setShowSpinner] = useState(false);

    const location = GeoLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const userName = useSelector((state) => state?.userDetailReducer?.userData?.userName);
    const markers = useSelector((state) => state?.pointListReducer?.pointListData);

    const toggle = () => {
        setShowModal(!showModal);
        setRoute(null);
    };

    const togglePermission = () => setShowPermissionModal(!showPermissionModal);

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: "AIzaSyDzh8-GocyaUY-Y1vg21IVA5M0vx6RuqI8"
    })

    const center = {
        lat: Number(location?.coordinates?.lat),
        lng: Number(location?.coordinates?.lng),
    };

    const defaultCenter = {
        lat: 47.2515110,
        lng: 21.1806770,
    }

    const handleActiveMarker = (marker) => {
        if (marker === activeMarker) {
            return;
        }
        setActiveMarker(marker);
    };

    useEffect(() => {
        setTimeout(() => {
            window?.scrollTo({ top: 0, behavior: 'smooth' })
        }, 0)
    }, []);

    useEffect(() => {
        const bounds = new window.google.maps.LatLngBounds();
        if (location?.loaded === true) {
            bounds?.extend(center);
        } else {
            bounds?.extend(defaultCenter);
        }
        map?.fitBounds(bounds);
        setMap(map);
    }, [location?.loaded]);

    useEffect(() => {
        // if (mounted) {
        fetchPointList();
        // }
        // return () => {
        //     setMounted(false);
        // };
    }, []);

    const fetchPointList = async () => {
        try {
            dispatch(showPointList());
        } catch (error) {
            toast.error(
                error?.startPoint?.message ||
                "Oops.. something went wrong, try again !!!",
                {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 2000,
                }
            );
        }
    }

    const createNewRoute = () => {
        setShowModal(false);
        setShowCreateRouteModal(true);
    };

    const addToRoute = (id) => {
        setMkmId(id)
        setShowModal(true);
    };

    const share = (id, poi) => {
        const data = `${window?.location?.protocol}//${window?.location?.host}/category-detail/${id}/${poi}`
        setLink(data)
        setShowShareModal(true);
    }

    const reportSuggestion = (title, id) => {
        setMkmId(id)
        setPointName(title)
        setShowReportModal(true);
    }

    const selectRoute = async () => {
        let existingData;
        if (route?.id) {
            try {
                let response = await routeDetail({
                    userName: userName,
                    routeID: route?.id
                });
                if (response && response?.status === 200) {
                    existingData = response?.data?.data
                }

                let requestBody = [];
                if (existingData?.length < 25) {
                    if (existingData?.length === 0) {
                        requestBody?.push({
                            mkmID: mkmID,
                            orderNumber: 0,
                            visited: false
                        });
                    } else if (existingData?.length === 1) {
                        requestBody?.push({
                            mkmID: existingData[0]?.place?.mkmID,
                            orderNumber: 0,
                            visited: false
                        });
                        requestBody?.push({
                            mkmID: mkmID,
                            orderNumber: 1,
                            visited: false
                        })
                    } else {
                        existingData?.splice(existingData?.length, 0, {
                            mkmID: mkmID,
                            orderNumber: existingData?.length,
                            visited: false
                        });
                        requestBody = existingData?.map((item, i) => {
                            return {
                                mkmID: item?.place?.mkmID || item?.mkmID,
                                orderNumber: i,
                                visited: item?.visited
                            }
                        });
                    }
                    try {
                        setShowSpinner(true);
                        let res = await updateRouteDetail(requestBody, {
                            userName: userName,
                            routeID: route?.id,
                        });
                        if (res && res?.status === 200) {
                            setActiveMarker(null)
                            toast.success("Point Added Successfully In Your Route!", {
                                position: toast.POSITION.TOP_RIGHT,
                                autoClose: 2000
                            })
                            setShowSpinner(false);
                        }
                    } catch (err) {
                        toast.error(
                            err?.response?.data?.message ||
                            "Oops.. something went wrong, try again !!!",
                            {
                                position: toast.POSITION.TOP_RIGHT,
                                autoClose: 2000,
                            }
                        );
                        setShowSpinner(false);
                    }
                    setRoute('');
                    setShowModal(false);
                }
                else {
                    toast.warning("Max of only 25 points can be added to a route, Kindly remove a point to add a new point.", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 2000
                    })
                    setShowSpinner(false);
                }
                setRoute('');
                setShowModal(false);
            } catch (error) {
                toast.error(
                    error?.response?.data?.message ||
                    "Oops.. something went wrong, try again !!!",
                    {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 2000,
                    }
                );
                setShowSpinner(false);
            };
        }
        if (!route?.id) {
            toast.error("Please Select The Route.", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000
            })
            setShowSpinner(false);
        }
    }

    const addToFavorite = async (id, fav) => {
        if (isUserLoggedIn) {
            const willFavorite = await swal({
                title: "Are you sure?",
                text: "You want to add this route in Favorites?",
                icon: marked_pop,
                buttons: true,
            })
            if (willFavorite) {
                try {
                    const obj = {
                        userName: userName
                    }
                    const data = {
                        mkmId: id,
                    }
                    const response = await addUserFavorite(data, obj)
                    setCheckForFavorite(fav);
                    if (response && response?.status === 200) {
                        swal("Added!", "Your route has been added in Favorites!", "success");
                    }
                } catch (error) {
                    toast.error(
                        error?.response?.data?.message ||
                        "Oops.. something went wrong, try again !!!",
                        {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 2000,
                        }
                    );
                }
            }
        }
        else {
            const notLoggedIn = await swal({
                title: "Please Continue to Log In",
                text: "You want to add this route in Favorites?",
                icon: marked_pop,
                buttons: ["Cancel", "Log In"],
            })
            if (notLoggedIn) {
                navigate('/sign-in');
            }
        }
    }

    const removeFromFavorite = async (id, fav) => {
        if (isUserLoggedIn) {
            const willRemoveFavorite = await swal({
                title: "Are you sure?",
                text: "You want to remove this route from Favorites?",
                icon: marked_pop,
                buttons: true,
            })
            if (willRemoveFavorite) {
                try {
                    const obj = {
                        userName: userName
                    }
                    const data = {
                        mkmId: id,
                    }
                    const response = await removeUserFavorite(data, obj)
                    setCheckForFavorite(fav);
                    if (response && response?.status === 200) {
                        swal("Removed!", "Your route has been removed from Favorites!", "success");
                    }
                } catch (error) {
                    toast.error(
                        error?.response?.data?.message ||
                        "Oops.. something went wrong, try again !!!",
                        {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 2000,
                        }
                    );
                }
            }
        }
        else {
            const notLoggedIn = await swal({
                title: "Please Continue to Log In",
                text: "You want to remove this route from Favorites?",
                icon: marked_pop,
                buttons: ["Cancel", "Log In"],
            })
            if (notLoggedIn) {
                navigate('/sign-in');
            }
        }
    }

    const onLoad = useCallback(async function callback(map) {
        const bounds = new window.google.maps.LatLngBounds();
        if (location?.loaded === true) {
            bounds?.extend(center);
        } else {
            bounds?.extend(defaultCenter);
        }
        map?.fitBounds(bounds);
        setMap(map);
    }, []);

    return (
        <div className="main_section explore_near_me">
            <Container>
            <SelectRouteModal
                route={route}
                setRoute={setRoute}
                showModal={showModal}
                toggle={toggle}
                createNewRoute={createNewRoute}
                selectRoute={selectRoute}
                showSpinner={showSpinner}
            />
            <CreateNewRouteModal
                showCreateRouteModal={showCreateRouteModal}
                setShowCreateRouteModal={setShowCreateRouteModal}
                showListModal={showListModal}
                setShowListModal={setShowListModal}
                routeName={routeName}
                setRouteName={setRouteName}
                pointName={pointName}
                setPointName={setPointName}
            />
            <PointsListingModal
                showListModal={showListModal}
                setShowListModal={setShowListModal}
                setRouteName={setRouteName}
                routeName={routeName}
                pointName={pointName}
                setPointName={setPointName}
            />
            <ReportSuggestionModal
                showReportModal={showReportModal}
                setShowReportModal={setShowReportModal}
                showListModal={showListModal}
                setShowListModal={setShowListModal}
                setRouteName={setRouteName}
                routeName={routeName}
                pointName={pointName}
                mkmID={mkmID}
            />
            <ShareModal
                showShareModal={showShareModal}
                setShowShareModal={setShowShareModal}
                link={link}
                setLink={setLink}
            />
            {/* <SearchBar /> */}
            <div className="breadcrumb_section">
                <Container>
                    <Breadcrumb className="breadcrumb">
                        <BreadcrumbItem>
                            <Link to="/" className="breadcrumb_item1">
                                Home
                            </Link>
                        </BreadcrumbItem>
                        <BreadcrumbItem active>
                            <Link to="#" className="breadcrumb_item2">
                                Explore Near Me
                            </Link>
                        </BreadcrumbItem>
                    </Breadcrumb>
                </Container>
            </div>
            <div className="explore_near_me_section">
                <Container fluid>
                    <div className="explore_near_me_box">
                        <div className="map">
                            {isLoaded ?
                                <GoogleMap
                                    mapContainerStyle={containerStyle}
                                    // center={center}
                                    onLoad={onLoad}
                                    options={{
                                        minZoom: 2,
                                        maxZoom: 17,
                                        gestureHandling: 'greedy'
                                    }}
                                    zoom={12}
                                >
                                    {markers?.map(item =>
                                        <div key={item?.id}>
                                            <Marker
                                                position={{ lat: Number(item?.poi?.split(",")[0]), lng: Number(item?.poi?.split(",")[1]) }}
                                                onClick={() => handleActiveMarker(item?.id)}
                                                onLoad={marker => {
                                                    const customIcon = (opts) => Object.assign({
                                                      path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z',
                                                      fillColor: '#34495e',
                                                      fillOpacity: 1,
                                                      strokeColor: 'teal',
                                                      strokeWeight: 2,
                                                      scale: 1,
                                                    }, opts);
                                                    item?.categoryId === 1 ?
                                                    marker.setIcon(customIcon({fillColor: '#d2b48c',strokeColor:'white'})) :
                                                    item?.categoryId === 10 ?
                                                    marker.setIcon(customIcon({fillColor: 'teal',strokeColor: "white"})) :
                                                     item?.categoryId === 5 ? marker.setIcon(customIcon({fillColor:"turquoise",strokeColor: "white"})) :
                                                      item?.categoryId === 4 ? marker.setIcon(customIcon({fillColor:"gold" ,strokeColor:"white"})) :
                                                       item?.categoryId === 2 ? marker.setIcon(customIcon({fillColor:"#000080" ,strokeColor:"white"})) :
                                                        item?.categoryId === 7 ? marker.setIcon(customIcon({fillColor:"#00ffff" ,strokeColor: "white"})) :
                                                         item?.categoryId === 9 ? marker.setIcon(customIcon({fillColor:"tomato" ,strokeColor: "white"})) :
                                                          item?.categoryId === 12 ? marker.setIcon(customIcon({fillColor:"wheat",strokeColor:"white" })) :
                                                          marker.setIcon(customIcon({fillColor:"wheat" }))
                                                    return handleActiveMarker(marker, item)
                                                    }}
                                            >
                                                {activeMarker === item?.id && (
                                                    <InfoWindow onCloseClick={() => setActiveMarker(null)}>
                                                        <div className="info_window"> <Card body>
                                                            <div className="card_header">
                                                                {item?.userFavorite === true ? <Button className='favourite_fill_icon'
                                                                    onClick={() => removeFromFavorite(item?.id)}
                                                                ><AiFillStar size={20} /></Button> :
                                                                    <Button className="favourite_icon"
                                                                        onClick={() => addToFavorite(item?.id)}
                                                                    ><AiOutlineStar size={20} /></Button>
                                                                }
                                                                <div className="right_section">
                                                                {item?.categoryId === 12 ?
                                                                    <Link className='card_link' to={`/category-detail/?tzadikimId=${item?.id}&cor=${item?.poi}`} state={{ from: 'exploreNearMe' }}>
                                                                        <CardTitle tag="h5" title={item?.mkmTitle}>{item?.mkmTitle}</CardTitle>
                                                                    </Link>
                                                                    :
                                                                    <Link className='card_link' to={`/category-detail/?MkmId=${item?.id}&cor=${item?.poi}`} state={{ from: 'exploreNearMe' }}>
                                                                        <CardTitle tag="h5" title={item?.mkmTitle}>{item?.mkmTitle}</CardTitle>
                                                                    </Link>
                                                                }    
                                                                    <Dropdown className="moreInfo" toggle={() => { setMenuOpen(!dropdownMenuOpen) }}
                                                                        isOpen={dropdownMenuOpen}
                                                                    >
                                                                        <DropdownToggle>
                                                                            <BiDotsVerticalRounded size={20} />
                                                                        </DropdownToggle>
                                                                        <DropdownMenu>
                                                                            <DropdownItem >
                                                                                <Link to={`/along-the-way-to-here/${item?.poi}`} state={{ from: 'exploreNearMe' }} className="breadcrumb_item1">Along the way to here</Link>
                                                                            </DropdownItem>
                                                                            <DropdownItem onClick={() => reportSuggestion(item?.mkmTitle, item?.id)}>
                                                                                Report suggestion
                                                                            </DropdownItem>
                                                                        </DropdownMenu>
                                                                    </Dropdown>

                                                                </div>
                                                            </div>
                                                            <CardText className="grid_text_le">{item?.cityY + " "} &nbsp; {item?.stateY}</CardText>
                                                            <div className="card_bottom">
                                                                <Button onClick={() => share(item?.id, item?.poi)}><FiShare2 size={20} /></Button>
                                                                <div className="right_section">
                                                                    <CardText>{item?.cityE + " " + item?.stateE}</CardText>
                                                                    <MdLocationOn className="location_icon" size={18} />
                                                                </div>
                                                            </div>
                                                            <div className="card_footer">
                                                                <Link to={`/explore-near-by/${item?.poi}`} state={{ from: 'exploreNearMe' }} className="btn explore"><BiExitFullscreen className="explore_icon" />Explore Near By</Link>
                                                                {item?.categoryId === 12 ?
                                                                <Link to={`/category-detail/?tzadikimId=${item?.id}&cor=${item?.poi}`} state={{ categoryName :  'Tzadikim'  , from: 'exploreNearMe' }} className="btn viewmore">View More</Link>
                                                                :
                                                                <Link to={`/category-detail/?MkmId=${item?.id}&cor=${item?.poi}`} state={{ categoryName : 'Cemeteries'  , from: 'exploreNearMe' }} className="btn viewmore">View More</Link>
                                                                }
                                                                <Button className="btn addroute" onClick={() => addToRoute(item?.id)}><FiBriefcase className="addroute_icon" />Add to Route</Button>
                                                            </div>
                                                        </Card></div>
                                                    </InfoWindow>
                                                )}
                                            </Marker>
                                        </div>
                                    )}
                                    {location?.loaded === true &&
                                        <Marker
                                            position={{
                                                lat: Number(location?.coordinates?.lat),
                                                lng: Number(location?.coordinates?.lng),
                                            }}
                                            icon={{ url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png" }}
                                        />
                                    }
                                    {location?.loaded === false &&
                                        <Modal className='map_permission' isOpen={showPermissionModal} modalTransition={{ timeout: 1000 }} toggle={togglePermission}>
                                            <ModalHeader toggle={togglePermission}></ModalHeader>
                                            <ModalBody>
                                                <p>
                                                    You have blocked location permission. Please allow location permission.
                                                </p>
                                                <div className="d-flex justify-content-center">
                                                    <h4>This steps you can follow </h4>
                                                </div>
                                                <div className="d-flex justify-content-center">
                                                    <h6>
                                                        Goto Setting - Privacy and Security - Site Settings -
                                                        Website - Enable Location
                                                    </h6>
                                                </div>
                                            </ModalBody>
                                        </Modal>
                                    }

                                </GoogleMap>
                                : <></>}
                        </div>
                    </div>
                </Container>
            </div>
            </Container>
        </div>
    );
}

export default ExploreNearMe